import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { HStack } from "@design-system/HStack/HStack";
import { Tag } from "@design-system/Tag/Tag";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { OrganizationTaskTemplateRow } from "../organizationTaskTemplatesViewConfig";
import { getOrganizationTaskTemplatesTableMeta } from "../organizationTaskTemplatesTableMeta";

export const OrganizationTaskTemplateNameCell = memo(
    function OrganizationTaskTemplateNameCell({
        row,
        table,
    }: CellContext<ViewTableFeatures, OrganizationTaskTemplateRow, string>) {
        const meta = getOrganizationTaskTemplatesTableMeta(table);
        const { id, name } = row.original;
        const isArchived = meta?.templatesById.get(id)?.archivedAt != null;

        return (
            <ViewTableCell>
                <HStack as="span" align="center" gap={8}>
                    <BreakableText showTooltip text={name} />
                    {isArchived && (
                        <Tag color="neutral" size="sm">
                            Archived
                        </Tag>
                    )}
                </HStack>
            </ViewTableCell>
        );
    },
);
